import { useQuery } from '@tanstack/react-query';
import {
  transactionsQueryOptions,
  transactionQueryOptions,
  userTransactionsQueryOptions,
} from '../server/queries/transactions';

/**
 * Fetches the full list of transactions.
 */
export function useTransactions() {
  return useQuery(transactionsQueryOptions());
}

/**
 * Fetches a single transaction by ID.
 */
export function useTransaction(id: string) {
  return useQuery(transactionQueryOptions(id));
}

/**
 * Fetches all transactions belonging to a single user.
 */
export function useUserTransactions(userId: string) {
  return useQuery(userTransactionsQueryOptions(userId));
}
